import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="flex flex-col items-center justify-center min-h-[80vh] px-6 text-center pt-20">
        <h1 className="font-heading text-6xl md:text-8xl font-extrabold text-primary-500 mb-4">
          404
        </h1>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
          Page Not Found
        </h2>
        <p className="text-base text-foreground-500 max-w-[440px] mb-8">
          The page you are looking for might have been moved or does not exist. Let us get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-home-line"></i>
            Back to Home
          </Link>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Visit Official Platform
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}